import { Component, ChangeDetectorRef, Injector, inject } from '@angular/core';
import { routes } from 'src/routes';
import { NotificationsService } from './notifications/notifications.service';
import { ReactiveComponent, PagesV2Module } from '@schenck/rotec-components';
import { RoutingGuardService } from 'src/services';
import { Observable } from 'rxjs';
import { Routes } from 'src/api';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { TranslateDirective } from '@ngx-translate/core';

/**
 * Navigation component.
 */
@Component({
  selector: 'mc-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.less'],
  imports: [PagesV2Module, RouterLinkActive, RouterLink, TranslateDirective, AsyncPipe],
})
export class PagesComponent extends ReactiveComponent {
  private readonly routingService = inject(RoutingGuardService);
  private readonly injector = inject(Injector);
  private readonly cdr = inject(ChangeDetectorRef);

  private notificationsService!: NotificationsService;
  conditionLink = routes.condition.absoluteUrl;
  notificationsLink = routes.notifications.absoluteUrl;
  operatorsLink = routes.operators.absoluteUrl;
  productionLink = routes.production.absoluteUrl;
  qualityLink = routes.quality.absoluteUrl;
  statisticsLink = routes.statistics.absoluteUrl;

  routingConfig$: Observable<Routes> = this.routingService.routingConfig$;

  state = this.connect(
    {
      nrOfNotificationsSinceLastVisit: this.routingConfig$.pipe(
        map((routingConfig) =>
          routingConfig.notifications && this.notificationsService
            ? this.notificationsService.nrOfNotificationsSinceLastVisit$
            : 0
        )
      ),
    },
    this.cdr
  );

  constructor() {
    super();
    const injector = this.injector;

    this.routingConfig$.pipe(
      map((routingConfig) => {
        if (routingConfig.notifications) {
          this.notificationsService = injector.get<NotificationsService>(NotificationsService);
        }
      })
    );
  }
}
